import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavService } from '../nav.service';
import { Nav } from '../nav.interface';


@Component({
  moduleId: module.id,
  selector: 'navs-component, [navsComponent]',
  template: `<ng-content></ng-content>`,
  styleUrls: ['navs.component.scss'],
  providers: [NavService],
})
export class NavsComponent implements OnInit, OnDestroy {

  @Output() selectItem: EventEmitter<Nav> = new EventEmitter();
  private subscription: Subscription;

  constructor(private navService: NavService) {}

  ngOnInit() {
    this.subscription = this.navService.select.subscribe((nav: Nav) => {
      this.selectItem.emit(nav);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {  this.subscription.unsubscribe(); }
    this.navService.reset();
  }
}
